import axios from "axios";
import { toast } from "react-toastify";
import swal from "sweetalert";
import { Logout } from "../store/actions/AuthActions";

axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["Accept"] = "application/json";

const UNAUTHORIZED_MESSAGES = [
	"not_authorized",
	"not_authorized_old_Token",
	"غير مصرح به (رمز قديم)",
];
const USER_NOT_FOUND_MESSAGES = ["المستخدم غير موجود", "User_not_Exist"];
const WRONG_PASSWORD_MESSAGES = ["كلمة سر خاطئة", "Incorrect_Password"];

let interceptorId = null;

function setInterceptors(navigate) {
	if (interceptorId !== null) {
		axios.interceptors.response.eject(interceptorId);
	}

	interceptorId = axios.interceptors.response.use(null, (error) => {
		const message = error?.response?.data?.message;
		const status = error?.response?.status;

		if (axios.isCancel(error)) {
			return Promise.reject(error);
		}

		if (UNAUTHORIZED_MESSAGES.includes(message)) {
			Logout(navigate);
		} else if (USER_NOT_FOUND_MESSAGES?.includes(message)) {
			swal("Oops", "Email not found", "error", { button: "Try Again!" });
		} else if (WRONG_PASSWORD_MESSAGES.includes(message)) {
			swal("Oops", "Incorrect Password", "error", { button: "Try Again!" });
		} else if (error?.response) {
			toast.error(message || `Request failed (${status})`);
		} else {
			toast.error(error?.message || "Network error");
		}
		return Promise.reject(error);
	});
}

function setJwt(jwt) {
	if (jwt) {
		axios.defaults.headers.common["Authorization"] = `${jwt}`;
	} else {
		delete axios.defaults.headers.common["Authorization"];
	}
}
const obj = {
	get: axios.get,
	post: axios.post,
	put: axios.put,
	patch: axios.patch,
	delete: axios.delete,
	setJwt,
	setInterceptors,
};
export default obj;
